export const menuData = [
  {
    category: "Appetizers",
    items: [
      {
        name: "Spring Rolls",
        description: "Crispy rolls filled with vegetables and minced meat.",
        price: "5,000 RWF",
      },
      {
        name: "Samosas",
        description: "Fried pastry with a savory filling, such as spiced potatoes, onions, peas.",
        price: "4,500 RWF",
      }
    ]
  },
  {
    category: "Main Courses",
    items: [
      {
        name: "Grilled Tilapia",
        description: "Whole tilapia fish grilled with local spices, served with a side of your choice.",
        price: "12,000 RWF",
      },
      {
        name: "Beef Brochettes",
        description: "Tender beef skewers, grilled to perfection.",
        price: "8,000 RWF",
      },
      {
        name: "Chicken Curry",
        description: "Aromatic chicken curry served with rice or chapati.",
        price: "9,500 RWF",
      }
    ]
  },
  {
    category: "Desserts",
    items: [
      {
        name: "Fruit Salad",
        description: "A fresh mix of seasonal tropical fruits.",
        price: "4,000 RWF",
      },
      {
        name: "Ice Cream",
        description: "Two scoops of vanilla or chocolate ice cream.",
        price: "3,500 RWF",
      }
    ]
  },
  {
    category: "Beverages",
    items: [
      {
        name: "Fresh Juice",
        description: "Passion fruit, pineapple, or mango.",
        price: "3,000 RWF",
      },
      {
        name: "Soft Drinks",
        description: "Coke, Fanta, Sprite.",
        price: "1,500 RWF",
      }
    ]
  }
];
